/*
 * Before updating the version, make sure you have
 * added the necessary migrations according as described
 * in the "Creating a new version for types" section of the
 * README.
 */
export var currentSystemDataVersion = 1;
export * from "./types-versions/types.v1";
